// extracted by mini-css-extract-plugin
module.exports = {"summaryContainer":"Benefits_summaryContainer__2sySL","dataSection":"Benefits_dataSection__3PSyk","color":"Benefits_color__3-08t"};